import React from "react";
import { FAQWrap, Title, Separator, Link, Footer } from "./styled";

const FAQ = () => {
  const email = "mailto:creators@joinfoody.com";
  return (
    <FAQWrap>
      <Title>Still have questions? </Title>
      <Separator />
      <Footer>
        Check out our{" "}
        <Link href="https://www.notion.so/joinfoody/Foody-Creator-Frequently-Asked-Questions-b62d9dc21873484081ef1e2e576b980d">
          Frequently Asked Questions
        </Link>{" "}
        page, or drop us a note at <Link href={email}>creators@joinfoody.com</Link>
      </Footer>
    </FAQWrap>
  );
};

export default FAQ;
